import ButtonIcon from "tds/buttonIcon";

export { ButtonIcon };

customElements.define("tds-button-icon", ButtonIcon.CustomElementConstructor);
